import { HeaderColumn, HelpTable } from './helpTable';
import { Title } from '../../basic/help/title';
import { Image } from '../../basic/help/image';
import { ProcedureFormat } from '../../basic/help/procedureFormat';
import { Step } from '../../basic/help/step';
import { Text } from '../../basic/help/text';

import ConfirmExecuteLogImg1 from '../../../img/manual/confirmExecuteLog/confirmExecuteLogImg1.svg';
import ConfirmExecuteLogImg2 from '../../../img/manual/confirmExecuteLog/confirmExecuteLogImg2.svg';
import ConfirmExecuteLogImg3 from '../../../img/manual/confirmExecuteLog/confirmExecuteLogImg3.svg';
import ConfirmExecuteLogImg4 from '../../../img/manual/confirmExecuteLog/confirmExecuteLogImg4.svg';

// カラム定義
type confirmExecuteLogColumn = {
  item: string;
  description: string;
};

// ヘッダー定義
const headerColumns: HeaderColumn<confirmExecuteLogColumn>[] = [
  { id: '1', key: 'item', name: '項目', width: 20 },
  { id: '2', key: 'description', name: '説明', width: 80 },
];

const dataList: confirmExecuteLogColumn[] = [
  {
    item: '状態',
    description: `アプリの実行結果を表しています。
    状態は、正常終了とエラーの2つになります。`,
  },
  {
    item: '実行開始日時',
    description: `RICOH Chatbot Service アプリ連携を実行した日時です。
    ボタンをクリックすることでRICOH Chatbot ServiceからRICOH Chatbot Service アプリ連携へのリクエストボディのパラメータを確認できます。`,
  },
  {
    item: '実行終了日時',
    description: `RICOH Chatbot Service アプリ連携が実行終了した日時です。
    ボタンをクリックすることで、RICOH Chatbot Service アプリ連携からRICOH Chatbot Serviceへのレスポンスボディのパラメータを確認できます。`,
  },
  {
    item: 'エラー内容',
    description: `状態がエラーの場合、エラーの内容が表示されます。
    正常終了した場合は、何も表示されません。`,
  },
];

export const ConfirmExecuteLog = () => {
  return (
    <div>
      <Title>実行ログの確認方法</Title>
      <ProcedureFormat>
        <Step>実行ログを確認したいアプリの[設定]ボタンをクリックします。</Step>
        <Image
          src={ConfirmExecuteLogImg1}
          alt="confirmExecuteLog1"
          width={60}
        />
        <Step>アプリ実行履歴に実行ログが表示されます。</Step>
        <Image
          src={ConfirmExecuteLogImg2}
          alt="confirmExecuteLog2"
          width={60}
        />
      </ProcedureFormat>

      {/* テーブル表示部分 */}
      <HelpTable
        header={headerColumns}
        body={dataList}
        id="confirmExecuteLog"
        width={90}
      />

      <Text>
        以下、実行開始日時と実行終了日時にあるボタンをクリックした際に表示される画面例です。
      </Text>
      <Image
        src={ConfirmExecuteLogImg3}
        alt="confirmExecuteLog3"
        width={40}
        title={'リクエストボディのパラメータ例'}
      />
      <Image
        src={ConfirmExecuteLogImg4}
        alt="confirmExecuteLog4"
        width={40}
        title={'レスポンスボディのパラメータ例'}
      />
    </div>
  );
};
